import { useContext, useEffect, useState } from 'react';
import { PrivilegeContext } from '../../../components/priviledge/PriviledgeProvider';
import { ExpirationService } from '../../../services/expiration/expirationService';
import { State } from '../../../type/entities/state-type';

/*-----------------------------------------------------------------------------------------------
* EN: Hook to manage payment methods fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de métodos de pago.
-----------------------------------------------------------------------------------------------*/

const usePaymentMethods = (withPermission = false) => {

    const { userCan } = useContext(PrivilegeContext);
    const [data, setData] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const fetchPaymentMethods = async () => {
        if (withPermission && !userCan('admin_expirations', 'expirations')) return;
        setIsLoading(true);
        try {
            const service = new ExpirationService();
            const response = await service.getPaymentMethods();
            const fetchedData = response.getResponseData()?.data;

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: State) => ({
                    value: data.id,
                    label: data.name,
                }));
                setData(mappedData);
            }
        } catch (error) {
            console.log('Error fetching payment methods:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchPaymentMethods();
    }, []);

    const getPaymentMethodsList = (entity?: string | null, notShowStatusID?: string | null) => {
        if (entity) return data.filter((state: any) => state.entity === entity);
        if (notShowStatusID) return data.filter((state: any) => state.value !== notShowStatusID);
        return data;
    };

    return { fetchPaymentMethods, getPaymentMethodsList, isLoadingPaymentMethods: isLoading };
}

export default usePaymentMethods;